export default "__VITE_ASSET__CCPzTMwA__"